import { useEffect, useState } from "react";
import { Modal } from "antd";
import { useUserInfo, useUserInfoDispath } from "@/model";
import Account from "./components/Account";
import logoPng from "@/images/login/logo.png";
import leftPng from "@/images/login/left.png";
import classNames from "classnames";
import Code from "./components/Code";
import { env } from "@/utils/env";
import "./index.less";
import { useNavigate } from "react-router";

const Login = () => {
  const userInfo = useUserInfo();
  const dispatch = useUserInfoDispath();
  const navigate = useNavigate();
  const [logoType, setLogoType] = useState("account");

  const changeLogoType = (e: any) => {
    const type = e.target.getAttribute("data-type");
    if (type && logoType !== type) {
      setLogoType(type);
    }
  };

  useEffect(() => {
    if (userInfo.openModal && env.isMobile) {
      navigate("/login");
      dispatch({ type: "login/close" });
    }
  }, [navigate, dispatch, userInfo.openModal]);

  return (
    <Modal
      open={userInfo.openModal && !env.isMobile}
      onCancel={() => dispatch({ type: "login/close" })}
      footer={null}
      maskClosable={false}
      className="login-modal"
      width={850}
    >
      <div className="login-modal-content">
        <div className="login-content left flex-c-c">
          <img className="logo" src={logoPng} alt="" />
          <img width={270} src={leftPng} alt="" />
        </div>
        <div className="login-content right">
          <ul className="logo-type flex" onClick={changeLogoType}>
            <li
              className={classNames([
                "pointer",
                { active: logoType === "account" },
              ])}
              data-type="account"
            >
              账号登录
            </li>
            <li
              className={classNames([
                "pointer",
                { active: logoType === "code" },
              ])}
              data-type="code"
            >
              验证码登录
            </li>
          </ul>
          {logoType === "account" ? <Account /> : <Code />}
        </div>
      </div>
    </Modal>
  );
};

export default Login;
